<template>
  <div class="main_wrapper" v-if="apidata">
    <RainSplash></RainSplash>
    <!-- <Sun></Sun> -->

    <!-- <img :src='require("./assets/stamp.svg")'> -->
    <div v-if="today < '2018-09-10' && show" class="announcement">
      <span class="close" @click="show = false"/>
     <a class="announcement_img" href="https://www.facebook.com/events/1756799031042232/" target="_blank">
        <img :src="image"/>
      </a>
    </div>

    <div class='text'>
      <p style='margin-bottom: -14px'>FANFARE INC.</p>
      <p v-if="about" v-html="about[2]" class='footerText footerText_letterspacing' style='margin-bottom: 5px'></p>
    </div>

    <div class='home_elements'>
      <router-link 
        v-for="issue in issues"
        :to="{ path: issue.uid }"
        :class="{clicked: buttonActive == issue}"
        class='home_elements_child'
        v-on:click.native="buttonClick(issue)"
      >  
        <ul class='home_elements_child_inner'>
          <li>Issue</li>
          <li>{{issue.number-1}}</li>
          <li>{{issue.title}}</li>
        </ul>
      </router-link>
      <router-link 
        to="tetatet"
        class='home_elements_child exception'
        :class="{clicked: buttonActive == 'Tetatat'}"
        v-on:click.native="buttonClick('Tetatat')"
      >  
        <ul class='home_elements_child_inner'>
          <li>tetatet</li>
        </ul>
      </router-link>
    </div>

    <div class='text'>
      <span class='footerLink'>
        <a href='mailto:inc@fanfarefanfare.nl'>CONTACT</a>
        <a href='http://fanfarefanfare.nl/' target="_blank">WEBSITE</a>
        <a href='https://www.facebook.com/fanfarefanfarefanfarefanfarefanfarefanfarefanfare/?' target="_blank">FACEBOOK</a>
        <router-link 
          to="colophon"
        >  
        COLOPHON
        </router-link>
        
      </span>
    </div>

  </div> 
</template>

<script>
  import _ from 'underscore'
  import Sparkle from './library/sparkle.vue'
  import RainSplash from './library/rainSplash.vue'
  import moment from 'moment'
  import Img from '.././assets/fban.svg'
  
  export default {
    name: 'Home',
    components: {
      RainSplash,
      
      // Sun
    },
    data () {
      return { 
        buttonActive: undefined,
        image: Img,
        show: true
      }
    },
    computed: {
      apidata () {
        return this.$store.state.apidata
      },
      about () {
        return _.values(this.apidata['3-about'])
      },
      issues () {
        return _.values(this.apidata['1-issues']).reverse()
      },
      today () {
        return moment().format('YYYY-MM-DD')
      }
    },
    mounted: function () {
      this.$store.state.classBody = 'home'
      this.$store.state.compass = false
    },
    methods: {
      buttonClick: function (name) {
        this.buttonActive = name
      },
      destroy: function () {
          this.$destroy();
      }
    }, 
    beforeRouteLeave (to, from, next) {
      this.$store.state.previousRoute = 'home'
      if(to.name != "Colophon") {
        const time = Math.floor(Math.random() * 1000) + 400  
        this.$store.state.compass = true 
        setTimeout(function(){ next() }, time)
      } else {
        next()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../styles/global.less";
  
  .announcement {
    position: fixed;
    right: 40px;
    bottom: 30px; 
    z-index: 200000;
    box-shadow: 0px -10px 10px rgba(200,200,200,.2), -10px 0px 10px rgba(200,200,200,.3);
    -webkit-animation: tada 3s ease infinite;
    -moz-animation: tada 3s ease infinite;
    animation: tada 3s ease infinite;
    img {
      width: 200px;
    }
  }

  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 32px;
    height: 32px;
    opacity: 0.3;
    pointer: cursor;
  }
  .close:hover {
    opacity: 1;
  }
  .close:before, .close:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 33px;
    width: 4px;
    background-color: #333;
    box-shadow: 0px 4px 5px grey;
  }
  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }

  .home_elements {
    margin: 0 0 @mp-c 0;
    &_child {
      position: relative;
      display: block;
      padding: @mp-c;
      margin: @mp-c*1.15 @mp-b;

      width: calc(~"100% - @mp-b*2");
      height: 340px;

      background: @black;
      color: @white;
      .fs-m;

      // -webkit-clip-path: polygon(20px  0%, calc(~"100% - 20px ") 0%, 100% 20px , 100% calc(~"100% - 20px "), calc(~"100% - 20px ") 100%, 20px  100%, 0% calc(~"100% - 20px "), 0% 20px ); 
      // clip-path: polygon(20px  0%, calc(~"100% - 20px ") 0%, 100% 20px , 100% calc(~"100% - 20px "), calc(~"100% - 20px ") 100%, 20px  100%, 0% calc(~"100% - 20px "), 0% 20px );
      // -ms-clip-path: polygon(20px  0%, calc(~"100% - 20px ") 0%, 100% 20px , 100% calc(~"100% - 20px "), calc(~"100% - 20px ") 100%, 20px  100%, 0% calc(~"100% - 20px "), 0% 20px );
      &_inner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        
        letter-spacing: .5px;
        text-align: center;
        text-transform: uppercase;

        pointer-events: none;
        user-select: none;
      }
    }
    &_child:hover {
      background: @blackLight;
    }
    &_child:first-of-type {
      margin-top: @mp-a*1.2;
    }
    .exception {
      background: linear-gradient(32deg, #1d1d1d, #3d3d3d, grey);
      background-size: 400% 400%;

      -webkit-animation: homeButtonBg 30s ease infinite;
      -moz-animation: homeButtonBg 30s ease infinite;
      animation: homeButtonBg 30s ease infinite;
    }
    .exception:hover {
      background: @blackLight;
    }
  }

  .clicked {
    -webkit-animation: bounceButtonDown .25s ease-in 1 !important;
    -moz-animation: bounceButtonDown .25s ease-out 1 !important;
    animation: bounceButtonDown .25s ease-out 1 !important;
  }

  @media screen and (max-width: @breakpoint1) {
    .home_elements {
      margin: 0 0 15px 0;
      &_child {
      margin: 15px;
      width: calc(~"100% - 30px");

      height: 240px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue